var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-block",attrs:{"x-test-name":"contact-details-review"}},[_vm._m(0),_c(_setup.InfoBlock,{attrs:{"emptyValue":"-","model":_setup.model,"info":_setup.infoBlock}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-3"},[_c('h2',[_vm._v("Contact Details")])])
}]

export { render, staticRenderFns }